import { camelizeKeys } from 'humps'
import cloneDeep from 'lodash/cloneDeep'

/**
 * Parent error for checked/handled Exception, throw by application code
 * This error class is handled and would not be sent to tracking system.
 *
 * We use exceptions as flow diverting mechanism, but we would also want
 * to differ them from the others (e.g while logging, or error tracking),
 * this class helps us for that
 */
class ApplicationError extends Error {
  constructor(message) {
    super(message)
    this.name = 'ApplicationError'
    this.isInternal = true
  }
}

class HttpRequestError extends ApplicationError {
  static parse = (error) => {
    const response = error.response || {}
    const status = response.status
    const data = response.data || {}

    return camelizeKeys({ status, data, message: error.message })
  }

  static getErrorCode = (error) => {
    const { data } = HttpRequestError.parse(error)
    const { errors = [] } = data
    if (!errors || !TypeChecker.isArray(errors)) {
      return ''
    }
    const firstError = errors[0] || {}

    return firstError.errorCode || ''
  }

  constructor(message, response, trackingKey) {
    super(message)
    this.name = 'HttpRequestError'
    this.trackingKey = trackingKey
    this.response = cloneDeep(response)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}

export { ApplicationError, HttpRequestError }
